import { render, staticRenderFns } from "./noedit.vue?vue&type=template&id=54ed61e4"
import script from "./noedit.vue?vue&type=script&lang=js"
export * from "./noedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports